// extracted by mini-css-extract-plugin
export default {"content":"Builder_content__lVPEN","content_pages":"Builder_content_pages__J056f"};